(function () {

  let noteSaveTimer = null;
  let noteSaveQueue = Promise.resolve();
  let checkoutInProgress = false;


  function getCartRoot() {
    return (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    )
      ? window.Shopify.routes.root
      : '/';
  }


  function getCurrentNotes() {

    const noteField = document.querySelector(
      '#CartSpecialInstructions'
    );

    const giftField = document.querySelector(
      '#CartGiftNote'
    );

    return {
      note: noteField ? noteField.value : '',
      gift_note: giftField ? giftField.value : ''
    };

  }


  function buildNotePayload() {

    const values = getCurrentNotes();

    return JSON.stringify({
      note: values.note,
      attributes: {
        gift_note: values.gift_note
      }
    });

  }


  function sendNoteSave(options) {

    options = options || {};

    const payload = buildNotePayload();

    return fetch(
      getCartRoot() + 'cart/update.js',
      {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

        body: payload,

        keepalive: options.keepalive === true
      }
    )
      .then(function (response) {

        if (!response.ok) {
          throw new Error(
            'Cart note save failed: ' +
            response.status
          );
        }

        return response.json();

      });

  }


  function saveNotesNow() {

    clearTimeout(noteSaveTimer);

    /*
     * Queue saves so multiple cart/update.js
     * requests do not overlap.
     */
    noteSaveQueue = noteSaveQueue
      .catch(function () {
        // Recover from an earlier failed save.
      })
      .then(function () {

        return sendNoteSave({
          keepalive: true
        });

      })
      .catch(function (error) {

        console.error(
          'Unable to save cart note/gift message:',
          error
        );

      });

    return noteSaveQueue;

  }


  function scheduleNoteSave() {

    clearTimeout(noteSaveTimer);

    noteSaveTimer = setTimeout(function () {
      saveNotesNow();
    }, 500);

  }


  function emergencyNoteSave() {

    clearTimeout(noteSaveTimer);

    /*
     * Final attempt to save if the customer
     * refreshes or navigates away.
     */
    try {

      fetch(
        getCartRoot() + 'cart/update.js',
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json'
          },

          body: buildNotePayload(),

          keepalive: true
        }
      );

    } catch (error) {

      console.error(
        'Emergency cart note save failed:',
        error
      );

    }

  }


  function restoreSavedCartNotes() {

    /*
     * Read the real Shopify cart after page load.
     *
     * If Capital displays an empty textarea even
     * though Shopify still has the saved value,
     * put the server-saved value back into the field.
     */
    fetch(
      getCartRoot() + 'cart.js',
      {
        headers: {
          'Accept': 'application/json'
        }
      }
    )
      .then(function (response) {

        if (!response.ok) {
          throw new Error(
            'Unable to read cart'
          );
        }

        return response.json();

      })
      .then(function (cart) {

        const noteField =
          document.querySelector(
            '#CartSpecialInstructions'
          );

        const giftField =
          document.querySelector(
            '#CartGiftNote'
          );


        /*
         * Never overwrite something the customer
         * has already started typing.
         */
        if (
          noteField &&
          !noteField.value &&
          cart.note
        ) {

          noteField.value =
            cart.note;

        }


        if (
          giftField &&
          !giftField.value &&
          cart.attributes &&
          cart.attributes.gift_note
        ) {

          giftField.value =
            cart.attributes.gift_note;

        }

      })
      .catch(function (error) {

        console.error(
          'Unable to restore saved cart notes:',
          error
        );

      });

  }


  function bindNoteAutosave() {

    const noteField =
      document.querySelector(
        '#CartSpecialInstructions'
      );

    const giftField =
      document.querySelector(
        '#CartGiftNote'
      );


    [noteField, giftField].forEach(
      function (field) {

        if (!field) return;


        /*
         * Avoid attaching the same listeners
         * more than once.
         */
        if (
          field.dataset.autosaveBound ===
          'true'
        ) {
          return;
        }


        field.dataset.autosaveBound =
          'true';


        /*
         * Save shortly after the customer
         * stops typing.
         */
        field.addEventListener(
          'input',
          scheduleNoteSave
        );


        /*
         * Save immediately when they leave
         * the field.
         */
        field.addEventListener(
          'blur',
          function () {

            clearTimeout(
              noteSaveTimer
            );

            saveNotesNow();

          }
        );


        /*
         * Additional fallback.
         */
        field.addEventListener(
          'change',
          function () {

            clearTimeout(
              noteSaveTimer
            );

            saveNotesNow();

          }
        );

      }
    );

  }


  function updateCart(line, quantity) {

    const cart =
      document.querySelector(
        '[data-wetheme-section-type="template--cart"]'
      );


    if (cart) {
      cart.classList.add(
        'is-updating'
      );
    }


    /*
     * Remember exactly what is currently
     * visible in the two text fields.
     */
    const noteField =
      document.querySelector(
        '#CartSpecialInstructions'
      );

    const giftField =
      document.querySelector(
        '#CartGiftNote'
      );


    const noteValue =
      noteField
        ? noteField.value
        : '';


    const giftValue =
      giftField
        ? giftField.value
        : '';


    /*
     * Save the note/gift message independently.
     *
     * We do NOT wait for this before starting
     * the quantity update, so quantity changes
     * remain fast.
     */
    saveNotesNow();


    /*
     * Start quantity update immediately.
     */
    fetch(
      getCartRoot() + 'cart/change.js',
      {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      }
    )
      .then(function (response) {

        if (!response.ok) {

          throw new Error(
            'Cart quantity update failed'
          );

        }

        return response.json();

      })

      .then(function () {

        return fetch(
          getCartRoot() +
          'cart?section_id=template--cart'
        );

      })

      .then(function (response) {

        return response.text();

      })

      .then(function (html) {

        const parser =
          new DOMParser();


        const doc =
          parser.parseFromString(
            html,
            'text/html'
          );


        const newCart =
          doc.querySelector(
            '[data-wetheme-section-type="template--cart"]'
          );


        const currentCart =
          document.querySelector(
            '[data-wetheme-section-type="template--cart"]'
          );


        if (
          newCart &&
          currentCart
        ) {

          currentCart.innerHTML =
            newCart.innerHTML;


          /*
           * Restore what the customer had typed
           * before the cart refresh.
           */
          const newNoteField =
            currentCart.querySelector(
              '#CartSpecialInstructions'
            );


          const newGiftField =
            currentCart.querySelector(
              '#CartGiftNote'
            );


          if (newNoteField) {

            newNoteField.value =
              noteValue;

          }


          if (newGiftField) {

            newGiftField.value =
              giftValue;

          }


          currentCart.classList.remove(
            'is-updating'
          );


          /*
           * New HTML means new elements,
           * so re-bind listeners.
           */
          bindCartEvents();
          bindNoteAutosave();

        }

      })

      .catch(function (error) {

        console.error(
          'Cart update failed:',
          error
        );


        if (cart) {

          cart.classList.remove(
            'is-updating'
          );

        }

      });

  }


  function bindCartEvents() {

    document
      .querySelectorAll(
        '.js-qty__adjust'
      )
      .forEach(
        function (button) {


          if (
            button.dataset.cartBound ===
            'true'
          ) {
            return;
          }


          button.dataset.cartBound =
            'true';


          button.addEventListener(
            'click',
            function (e) {

              e.preventDefault();

              e.stopImmediatePropagation();


              const wrapper =
                this.closest(
                  '.js-qty'
                );


              if (!wrapper) return;


              const input =
                wrapper.querySelector(
                  'input'
                );


              if (!input) return;


              const currentQty =
                parseInt(
                  input.value,
                  10
                ) || 1;


              let newQty =
                currentQty;


              if (
                this.classList.contains(
                  'js-qty__adjust--plus'
                )
              ) {

                newQty++;

              }


              if (
                this.classList.contains(
                  'js-qty__adjust--minus'
                )
              ) {

                newQty =
                  Math.max(
                    1,
                    currentQty - 1
                  );

              }


              input.value =
                newQty;


              const line =
                Array.from(
                  document.querySelectorAll(
                    'input[name="updates[]"]'
                  )
                ).indexOf(input) + 1;


              updateCart(
                line,
                newQty
              );

            },
            true
          );

        }
      );


    document
      .querySelectorAll(
        'input[name="updates[]"]'
      )
      .forEach(
        function (input) {


          input.onchange =
            function () {


              let quantity =
                parseInt(
                  this.value,
                  10
                );


              if (
                !quantity ||
                quantity < 1
              ) {

                quantity = 1;

                this.value = 1;

              }


              const line =
                Array.from(
                  document.querySelectorAll(
                    'input[name="updates[]"]'
                  )
                ).indexOf(this) + 1;


              updateCart(
                line,
                quantity
              );

            };

        }
      );

  }


  function bindCheckoutProtection() {

    document.addEventListener(
      'click',
      function (e) {


        const checkoutButton =
          e.target.closest(
            '.cart--button-checkout'
          );


        if (!checkoutButton) return;


        /*
         * After the final save has completed,
         * allow Shopify's normal checkout action.
         */
        if (checkoutInProgress) {
          return;
        }


        e.preventDefault();

        e.stopImmediatePropagation();


        clearTimeout(
          noteSaveTimer
        );


        checkoutInProgress =
          true;


        /*
         * Finish any queued save and perform
         * one final save before checkout.
         */
        noteSaveQueue
          .catch(function () {
          })

          .then(function () {

            return saveNotesNow();

          })

          .then(function () {


            const form =
              checkoutButton.closest(
                'form'
              );


            if (!form) {

              checkoutInProgress =
                false;

              return;

            }


            if (
              typeof form.requestSubmit ===
              'function'
            ) {

              form.requestSubmit(
                checkoutButton
              );

            } else {

              checkoutButton.click();

            }

          });

      },
      true
    );

  }


  /*
   * Final save attempt on refresh,
   * tab close or navigation.
   */
  window.addEventListener(
    'pagehide',
    emergencyNoteSave
  );


  document.addEventListener(
    'DOMContentLoaded',
    function () {

      bindCartEvents();

      bindNoteAutosave();

      bindCheckoutProtection();

      /*
       * Restore any note/message Shopify
       * already has saved on the server.
       */
      restoreSavedCartNotes();

    }
  );

})();